module.exports = __webpack_public_path__ + "img/male-elderly-head.c764de75.svg";